import { cn } from "@/lib/utils";
import { AlertCircle } from "lucide-react";

interface MobileListErrorProps {
  className?: string;
  title: string;
  message: string;
}

export const MobileListError = ({
  className,
  title,
  message,
}: MobileListErrorProps) => {
  return (
    <div className={cn("flex justify-center py-8", className)}>
      <div className="text-center max-w-sm mx-auto px-4">
        <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <AlertCircle className="w-6 h-6 text-red-600" />
        </div>
        <div className="text-gray-900 text-base font-medium mb-2">{title}</div>
        <div className="text-gray-500 text-sm">{message}</div>
      </div>
    </div>
  );
};
